import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionItemTransitionDetails } from '../models/action-item-transition-details';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../../../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class ActionItemAuditService {

  constructor(private httpClient:HttpClient) {  }

  getActionItemTransitionDetails = (actionItemNumber: string):
    Observable<ActionItemTransitionDetails> => {
    return this.httpClient.get<ActionItemTransitionDetails>(
      ApiConstants.ActionItem_Transition_Details_Api.replace('{actionItemNumber}',
      actionItemNumber));
  }
}
